module.exports = __webpack_public_path__ + "img/ntk_nav_delete_g.d5a89821.svg";